import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { EPinpointRequestStatus } from '@feathr/blackbox';
import { domainStatusToColorMap, domainStatusToLabelMap } from '@feathr/blackbox';
import { Pill } from '@feathr/components';

interface IProps {
  isLoading?: boolean;
  status: EPinpointRequestStatus | null | undefined;
}

function DomainRecordStatusPill({
  isLoading = false,
  status,
}: Readonly<IProps>): JSX.Element | null {
  if (isLoading) {
    return <Pill isLoading={true} />;
  }
  if (status === undefined) {
    return null;
  }

  const key = status ?? 'N/A';
  return <Pill theme={domainStatusToColorMap[key]}>{domainStatusToLabelMap[key]}</Pill>;
}

export default observer(DomainRecordStatusPill);
